"use strict";

exports.__esModule = true;
exports.propNames = exports.layoutPropNames = exports.systemProps = void 0;

var _core = require("./core");

var _config = require("./config");

var _pseudo = require("./pseudo");

var systemProps = (0, _core.compose)(_config.background, _config.border, _config.color, _config.flexbox, _config.layout, _config.outline, _config.grid, _config.others, _config.position, _config.shadow, _config.space, _config.typography, _config.transform, _config.list, _config.transition);
exports.systemProps = systemProps;
var layoutSystem = (0, _core.compose)(_config.space, _config.layout, _config.flexbox, _config.grid, _config.position);
var layoutPropNames = layoutSystem.propNames;
exports.layoutPropNames = layoutPropNames;
var propNames = [].concat(systemProps.propNames || [], _pseudo.pseudoPropNames);
exports.propNames = propNames;
//# sourceMappingURL=system.js.map